<template>
  <div class="result">
    <div class="icon-success"></div>
    <div>支付成功</div>
    <div class="price">
      <span v-if="!isCaiBi" class="symbol">￥</span>
      <strong class="s17 t1">{{ price }}</strong
      ><span v-if="isCaiBi" class="balance-unit"> 财币</span>
    </div>
    <div v-if="isCaiBi && balance" class="balance">剩余财币：{{ balance }}</div>
    <div class="buttons">
      <div class="button button-order" @click="closePage">关闭</div>
      <div class="button button-home" @click="goOrder">
        {{ payType === 2 ? '我的财币' : '查看订单' }}
      </div>
    </div>
  </div>
</template>

<script>
import appInfo from '@/assets/js/appInfo'

export default {
  name: 'PaySuccess',
  props: ['orderInfo', 'payMethod', 'payType'],
  computed: {
    price() {
      let _price = this.orderInfo && this.orderInfo.actualPrice
      if (typeof _price === 'number' && _price % 1 === 0) {
        _price = _price + '.00'
      }

      return _price
    },
    isCaiBi() {
      return this.payMethod === 3
    },
    balance() {
      return this.$store.state.user.balance.balance
    }
  },
  created() {
    this.$store.dispatch('user/getBalance')
  },
  methods: {
    closePage() {
      const url = appInfo.getParam('callback')
      const name = appInfo.getParam('name')

      window.open(url, name)

      setTimeout(() => window.close(), 1000)
    },

    /**
     * 跳转到订单页面
     */
    goOrder() {
      if (this.payType === 2) {
        this.$router.replace('/mine/vcurrency')
      } else {
        this.$router.replace('/mine/orders')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.result {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1;
  font-size: 20px;
  color: #000000;
}

.icon-success {
  width: 90px;
  height: 90px;
  margin: 100px auto 30px;
  background: url('./images/success.png') no-repeat center;
  background-size: contain;
}

.price {
  padding: 30px 0 50px;
  font-size: 28px;
  color: #000000;
}

.symbol,
.balance-unit {
  font-size: 20px;
}

.buttons {
  display: flex;
  justify-content: center;
  font-size: 14px;
  color: #262626;

  .button {
    width: 120px;
    height: 40px;
    background-color: #f0f0f0;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .button-order {
    margin-right: 70px;
  }
}

.balance {
  margin-top: -30px;
  padding-bottom: 30px;
  font-size: 16px;
  color: #858585;
}
</style>
